module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k9eoZ"))).then(() => parcelRequire('8rm4T'));